import { render, staticRenderFns } from "./buyPanel.vue?vue&type=template&id=85459aae&scoped=true"
import script from "./buyPanel.vue?vue&type=script&lang=js"
export * from "./buyPanel.vue?vue&type=script&lang=js"
import style0 from "./buyPanel.vue?vue&type=style&index=0&id=85459aae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85459aae",
  null
  
)

export default component.exports